
<router-outlet></router-outlet>

<!-- <app-footer></app-footer> -->
 <app-new-footer></app-new-footer>
